import { cilCalendar, cilNotes, cilUser } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CNavItem, CNavTitle } from "@coreui/react";
import AdminIcon from "components/icons/AdminIcon";

const VendorSideBarNav = [
  {
    component: CNavItem,
    name: "대시보드",
    to: "/vendor",
    icon: (
      <AdminIcon
        name="home"
        size={20}
        style={{ marginLeft: 16, marginRight: 16 }}
      />
    ),
  },
  {
    component: CNavTitle,
    name: "매출통계",
  },
  {
    component: CNavItem,
    name: "상품별 통계",
    to: "/vendor/product",
    icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "회원별 통계",
    to: "/vendor/customer",
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  },
];

export default VendorSideBarNav;
